import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import './CreateObjectTypePage.css'
import { useTransientDiRef } from '@/common/react/di-hooks'
import { TypeForm } from '../type-form/TypeForm'
import type { CreateTypeController } from '../type-form/CreateTypeController'

export { type PropertyDefinition } from '../gql/PropertyDefinition'

export default function CreateObjectTypePage() {
  const navigate = useNavigate()
  const params = new URLSearchParams(location.search)
  const spaceId = Number(params.get('spaceId'))

  const controller = useTransientDiRef<CreateTypeController>('CreateTypeController', (c) => {
    c.init({ spaceId, navigate })
  })

  return (
    <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '76%', display: 'flex', flexDirection: 'column' }}>
        <TypeForm
          label="Create a type:"
          initialName="My Type"
          submitLabel="Submit"
          controller={controller}
        />
      </Box>
    </Box>
  )
}
